module.exports = __webpack_public_path__ + "img/icon_identity_face.84091ce3.png";